import { render, staticRenderFns } from "./RoomSummary.vue?vue&type=template&id=6fee4fca"
import script from "./RoomSummary.vue?vue&type=script&lang=js"
export * from "./RoomSummary.vue?vue&type=script&lang=js"
import style0 from "./RoomSummary.vue?vue&type=style&index=0&id=6fee4fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports